import { render, staticRenderFns } from "./AccomplishedProjects.vue?vue&type=template&id=3794b118&"
import script from "./AccomplishedProjects.vue?vue&type=script&lang=js&"
export * from "./AccomplishedProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports